/* eslint-disable jsdoc/check-param-names */
import { ActionBrick, registerBrick, BrickContext } from 'olympe';

export default class MassChangeProcessMultiPartPOSTResponseForDisplay extends ActionBrick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {Array<object>} response
     * @param {object=} selectedApprover
     * @param {string} operation
     * @param {function(): void} forwardEvent
     * @param {function(Array<object>): void} setChangedRows
     * @param {function(Array<object>): void} setErrorRows
     */
    update($, [response, selectedApprover, operation], [forwardEvent, setChangedRows, setErrorRows]) {
        const parser = new window.DOMParser();
        const errors = [];
        const changedRows = [];
        let authorizationError = false;
        for (let i = 0; i < response.length; i++) {
            const statusCode = response[i].statusCode;
            const statusMessage = response[i].statusMessage;
            const xmlDoc = parser.parseFromString(response[i].xmlBody, 'text/xml');
            // If we have an error
            if (statusCode !== '201' && statusMessage !== 'Created') {
                const errorMessageNode = xmlDoc.querySelector('errordetail > message');
                const errorMessage = errorMessageNode && errorMessageNode.innerHTML ? errorMessageNode.innerHTML : '';

                if (errorMessage.includes('authorization')) {
                    // eslint-disable-next-line no-unused-vars
                    authorizationError = true;
                }

                errors.push({
                    errorStatusCode: statusCode,
                    errorStatusMessage: statusMessage,
                    id: errors.length,
                    errorMessage,
                });
            } else if (operation === 'Edit') {
                // extract changed props form response XML
                const propertiesNode = xmlDoc.querySelector(
                    'entry > link > inline > feed > entry > content > properties'
                );
                const row = {};
                for (const node of propertiesNode.children) {
                    const propValue = node.textContent;
                    if (propValue) {
                        const propName = node.tagName.substring(2); // remove "d:" at the start
                        row[propName] = propValue;
                    }
                }
                delete row.AgentId; // remove confusing ref to old Approver

                // the new userId match the selected approver (it should never be otherwise)
                // In case there is somehow a mismatch, display the UserID as ApproverName is not available in the response data
                row.ApproverName =
                    selectedApprover.ApproverId === row.UserId ? selectedApprover.ApproverName : row.UserId;

                changedRows.push(row);
            }
        }

        setChangedRows(changedRows);
        setErrorRows(errors);
        forwardEvent();
    }
}

registerBrick('0183c148a4d0ce40d2a9', MassChangeProcessMultiPartPOSTResponseForDisplay);
